export * from './tipo-movimentacao.pipe';
